import useI18n from '../../lib/useI18n';
import { CustomerName, CustomerQuoteWrapper, Quote } from './style';

export const CUSTOMER_QUOTES = [
  {
    translationKey: 'kutter',
    name: 'Veronika Konrad, Personal bei Kutter GmbH & Co. KG Bauunternehmung',
  },
  {
    translationKey: 'asklepios',
    name: 'Katharina Schroeder, Asklepios Kliniken GmbH & Co. KGaA',
  },
  {
    translationKey: 'apetito',
    name: 'Jana Köning, apetito AG',
  },
];

export const CustomerQuote = () => {
  const { translate } = useI18n('customer_quote');
  const { name, translationKey } = getRandomElement(CUSTOMER_QUOTES);

  return (
    <CustomerQuoteWrapper>
      <Quote>“{translate(`.${translationKey}`)}”</Quote>
      <CustomerName>{name}</CustomerName>
    </CustomerQuoteWrapper>
  );
};

const getRandomElement = (array) =>
  array[Math.floor(Math.random() * array.length)];
